<div #container class="container-park">
    <div class="container-park__status">
        <img src="/assets/images/map/white-stop-icon.svg">
        <span>
            {{'trafficStop'|translate}}
        </span>
    </div>
    <button (click)="onClickHideModal()" class="close">
        <i class="pi pi-times"></i>
    </button>
    <div class="container-park__content">
        <span class="text time-executing">{{'duration'|translate}}: {{ formattedDate?.diff | statusTimeFormat }}</span>
        <span class="text date">
            {{ formattedDate?.date }}
        </span>
        <span class="text car">
            {{ clickedVehicle?.Nm }}
        </span>
        
        <div class="column-bottom">
            <span class="street">
                {{ formattedStreet }}
            </span>

            <div class="column-bottom__actions">
                <a *ngIf="data" target="_blank" href="https://www.google.com/maps?t=k&q={{data.D.S.Lt}}+{{data.D.S.Ln}}" class="btn">
                    <img src="/assets/images/map/i-external-map-white.svg" alt="">
                </a>
                <button (click)="copyCords()" class="btn">
                    <img class="copy" src="/assets/images/shared/i-copy-black.svg" alt="">
                </button>
            </div>
        </div>
    </div>
</div>